(() => {
    document.querySelectorAll(".js-members-form").forEach(form => {
        form.addEventListener("submit", (e) => {
            e.preventDefault();

            form.classList.add("loading");

            const req = new FormData(form);

            req.set("site_id", site_id);

            fetch(`${site_url}ajax/functions.php`, {
                method: "POST",
                body: req
            })
                .then(res => res.json())
                .then(data => {
                    removeErrors(form);

                    if (data.result === "success") {
                        switch (req.get("type")) {
                            case "login":
                                localStorage.setItem("usename", data.username);
                                localStorage.setItem("session_start", true);

                                window.location.reload();
                                break;

                            case "register":
                            case "recover":
                                form.previousElementSibling.classList.contains("thankyouMsg") && form.previousElementSibling.classList.remove("hide");

                                form.classList.add("hide");
                                break;

                            case "reset":
                                form.previousElementSibling.classList.contains("thankyouMsg") && form.previousElementSibling.classList.remove("hide");

                                form.classList.add("hide");

                                setTimeout(() => {
                                    const marker = '/password-reset',
                                        path = location.pathname,
                                        idx = path.indexOf(marker);

                                    if (idx === -1)
                                        return;

                                    const parent = path.slice(0, idx) || '/';

                                    if (parent === path)
                                        return;

                                    location.replace(parent);
                                }, 1000);
                                break;
                        }
                    } else {
                        displayErrors(data, form);
                    }

                    form.classList.remove("loading");
                })
                .catch(error => console.error("Error:", error));
        });
    });
})();

function removeErrors(form) {
    form.querySelectorAll(".error").forEach(el => {
        el.id.includes("error") ? el.remove() : el.classList.remove("error");
    });

    if (form.querySelector(".errorMsg"))
        form.querySelector(".errorMsg").innerHTML = null;
}

function displayErrors(data, form) {
    for (let key in data) {
        if (!data.hasOwnProperty(key) || String(key).includes('result', 'errorMsg'))
            continue;

        const element = form.querySelector(`[name=${key}]`);

        if (!element)
            continue;

        element.classList.add("error");

        const errorLabel = document.createElement("label");
        errorLabel.id = `${key}-error`;
        errorLabel.className = "msg error";
        errorLabel.textContent = data[key] === 1 ? "This field is required." : data[key];
        element.after(errorLabel);
    }

    const errorMsgEl = form.querySelector(".errorMsg");

    if ((data.message || data.errorProcessRecovery || data.errorActiveAccount) && errorMsgEl) {
        errorMsgEl.innerHTML = data.message || data.errorProcessRecovery || data.errorActiveAccount;
    }
}